import { useState } from "react";

export type TransactionCardProps = {
  children: React.ReactNode;
  className?: string;
  onToggleChange?: (value: boolean) => void;
};

export default function TransactionCard({
  children,
  className = "",
  onToggleChange,
}: TransactionCardProps) {
  const [isOpen, setOpen] = useState(false);

  const handleClick = () => {
    const newValue = !isOpen;
    setOpen(newValue);
    onToggleChange?.(newValue);
  };
  return (
    <div className="w-full bg-[#010101] border border-[#353535] rounded-[4px] p-3">
      <div className={`${className}`}>{children}</div>
      <div
        className="flex justify-center pt-2 cursor-pointer"
        onClick={handleClick}
      >
        <img
          src={"/images/ic-vector-down.svg"}
          alt="Vector-Down"
          className={`w-1/5 h-[6.85px] transition-transform duration-300 ${isOpen ? "rotate-180" : ""} `}
        />
      </div>
    </div>
  );
}
